






















































































































































import { Component, Vue, PropSync, Ref } from "vue-property-decorator";
import { ValidationObserver } from "vee-validate";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { moneyMaskProperties } from "@/models/VuetifyMoneyModel";
import EspecialidadeAutocomplete from "@/components/saude/EspecialidadeAutocomplete.vue";
import { EspecialidadePrestadorModel } from "@/models/cadastros/saude/EspecialidadePrestadorModel";

@Component({
  components: {
    GsModalDialog,
    EspecialidadeAutocomplete,
  },
})
export default class Especialidades extends Vue {
  @Ref("especialidadePrestadorObserver")
  especialidadePrestadorObserver!: InstanceType<typeof ValidationObserver>;

  especialidadePrestador = {
    especialidade: undefined,
    valor: undefined,
  } as EspecialidadePrestadorModel;

  moneyMaskProperties = moneyMaskProperties;

  especialidadeIndex = -1;

  modalRemoverEspecialidade = false;

  validado = false;

  get isEspecialidadePrecificada(): boolean {
    return ["CONSULTA", "EXAME", "PROCEDIMENTO"].includes(
      this.especialidadePrestador.especialidade?.tipoAtendimento?.name || ""
    );
  }

  get exibeMensagemOrcado(): boolean {
    return !!this.especialidadePrestador.especialidade;
  }

  @PropSync("especialidadesPrestador", { required: true })
  especialidadesPrestadorSynced!: EspecialidadePrestadorModel[];

  remover(index: number) {
    this.especialidadeIndex = index;
    this.modalRemoverEspecialidade = true;
  }

  excluirEspecialidade() {
    this.especialidadesPrestadorSynced.splice(this.especialidadeIndex, 1);
    this.cancelarExclusao();
  }

  cancelarExclusao() {
    this.modalRemoverEspecialidade = false;
    this.especialidadeIndex = -1;
  }

  editar(index: number) {
    this.especialidadePrestador = Object.assign(
      {},
      this.especialidadesPrestadorSynced[index]
    );
    this.especialidadeIndex = index;
  }

  private verificarEspecialidadeDuplicada(): boolean {
    return !this.especialidadesPrestadorSynced.find(
      (ep) =>
        ep.especialidade?.id == this.especialidadePrestador.especialidade?.id
    );
  }

  private resetarFormAdicionarEspecialidade(): void {
    this.especialidadePrestador = {
      especialidade: undefined,
      valor: undefined,
    };
    // this.especialidades = [];
    this.especialidadePrestadorObserver.reset();
    this.especialidadeIndex = -1;
  }

  cancelarEdicao() {
    this.especialidadeIndex = -1;
    this.resetarFormAdicionarEspecialidade();
  }

  adicionarEspecialidade() {
    this.validado = false;
    const especialidade = Object.assign({}, this.especialidadePrestador);
    if (this.especialidadeIndex > -1) {
      this.especialidadesPrestadorSynced.splice(
        this.especialidadeIndex,
        1,
        especialidade
      );
      this.resetarFormAdicionarEspecialidade();
    } else if (this.verificarEspecialidadeDuplicada()) {
      this.especialidadesPrestadorSynced.push(especialidade);
      this.resetarFormAdicionarEspecialidade();
    } else {
      this.especialidadePrestadorObserver.setErrors({
        Especialidade: "Especialidade já atribuída.",
      });
    }
  }

  validar(dadosBasicosValid: boolean): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.especialidadesPrestadorSynced.length < 1) {
        this.especialidadePrestadorObserver.setErrors({
          Especialidade: "É necessário adicionar ao menos uma especialidade.",
        });
      }
      resolve(
        dadosBasicosValid && this.especialidadesPrestadorSynced.length > 0
      );
    });
  }

  scrollToError() {
    const errors = Object.entries(this.especialidadePrestadorObserver.refs)
      .map(([key, value]) => ({
        key,
        value,
      }))
      .filter((error) => {
        if (!error || !error.value || !error.value.failedRules) return false;
        return Object.keys(error.value.failedRules).length > 0;
      });
    if (errors && errors.length > 0) {
      this.especialidadePrestadorObserver.refs[
        errors[0]["key"]
      ].$el.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }
}
